import { useTranslation } from 'react-i18next';
import { Modal as BootstrapModal } from 'react-bootstrap';
import { Typography } from 'app/components/ui';

import './Modal.scss';

interface DeleteTagModalProps {
  show: boolean;
  busy?: boolean;
  onConfirm: () => void;
  onCancel: () => void;
  title?: string;
  message?: string;
  count?: number;
  chainCount?: number;
  onConfirmChain?: () => void;
}

export const DeleteTagModal = ({ show, busy = false, onConfirm, onCancel, title, message, count = 1, chainCount = 0, onConfirmChain }: DeleteTagModalProps) => {
  const { t } = useTranslation('tag');
  const many = count > 1;
  const askChain = !!onConfirmChain && chainCount > 1;

  return (
    <BootstrapModal
      show={show}
      onHide={onCancel}
      dialogClassName={askChain ? 'tags-modal__dialog--choice' : undefined}
      contentClassName={`tags-modal__content tags-modal__content--continuation ${askChain ? 'tags-modal__content--choice' : ''}`}
      centered
    >
      <button onClick={onCancel} type="button" aria-label="Close" className="tags-modal__close-btn">
        <i className="fa-solid fa-xmark" />
      </button>

      <div className="tags-modal__header">
        <i className="fa-solid fa-trash tags-modal__tag-icon tags-modal__tag-icon--danger" />

        <div className="tags-modal__title-group">
          <Typography variant="body-7" fontWeight="semibold" color="#1e2533">
            {title ?? (many ? t('manage.delete.modal.title') : t('delete.modal.title'))}
          </Typography>

          <Typography variant="body-7" fontWeight="light" color="#616066">
            {message ??
              (askChain ? t('delete.chain.message', { count: chainCount }) : many ? t('manage.delete.modal.message', { count }) : t('delete.modal.message'))}
          </Typography>
        </div>
      </div>

      <div className="tags-modal__actions">
        <button className="tags-modal__btn-cancel" onClick={onCancel}>
          {t('delete.modal.cancel')}
        </button>
        {askChain ? (
          <>
            <button className="tags-modal__btn-confirm" disabled={busy} onClick={onConfirm}>
              {t('delete.chain.one')}
            </button>
            <button className="tags-modal__btn-confirm tags-modal__btn-confirm--danger" disabled={busy} onClick={onConfirmChain}>
              {t('delete.chain.all', { count: chainCount })}
            </button>
          </>
        ) : (
          <button className="tags-modal__btn-confirm tags-modal__btn-confirm--danger" disabled={busy} onClick={onConfirm}>
            {t('delete.modal.confirm')}
          </button>
        )}
      </div>
    </BootstrapModal>
  );
};
